var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_76052)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.5C10.2532 7.5 6 11.7598 6 17.0161C6 21.2199 8.72175 24.7871 12.497 26.0449C12.972 26.1323 13.1449 25.8388 13.1449 25.5861C13.1449 25.3609 13.1374 24.7615 13.1326 23.9682C10.4897 24.543 9.93205 22.6924 9.93205 22.6924C9.50075 21.5923 8.87755 21.2997 8.87755 21.2997C8.01495 20.7107 8.9431 20.7221 8.9431 20.7221C9.89595 20.7886 10.3976 21.7025 10.3976 21.7025C11.245 23.156 12.6215 22.7361 13.162 22.4929C13.2494 21.8782 13.4946 21.4593 13.7663 21.2218C11.6573 20.9814 9.439 20.1644 9.439 16.5183C9.439 15.48 9.8095 14.6297 10.4166 13.9647C10.3187 13.7244 9.99285 12.7563 10.5097 11.4472C10.5097 11.4472 11.3076 11.1907 13.1221 12.4219C13.8971 12.2106 14.6967 12.1029 15.5 12.1018C16.3075 12.1056 17.1197 12.211 17.8788 12.4219C19.6923 11.1907 20.4884 11.4463 20.4884 11.4463C21.0071 12.7563 20.6803 13.7244 20.5834 13.9647C21.1914 14.6297 21.56 15.48 21.56 16.5183C21.56 20.1739 19.338 20.9786 17.2223 21.2142C17.5634 21.5077 17.8665 22.0882 17.8665 22.9764C17.8665 24.2475 17.855 25.2745 17.855 25.5861C17.855 25.8407 18.026 26.1371 18.5086 26.044C20.4004 25.4095 22.0449 24.1965 23.2097 22.5765C24.3745 20.9565 25.0008 19.0115 25 17.0161C25 11.7598 20.7459 7.5 15.5 7.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_76052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(6 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtGithubLogo);
export default __webpack_public_path__ + "static/media/at_github_logo.20d06102dcdd5ad198cb1918aa850b94.svg";
export { ForwardRef as ReactComponent };